import { $CurrentTraffic } from '@lemon8/web-app-shared/atom';
import { EPageType } from 'shared/models/page-type';
import { ExtractAtomValue } from 'jotai';
import { EKeywordSource } from '../experience';

export interface ICurrentTraffic extends ExtractAtomValue<typeof $CurrentTraffic> {
  pageType: EPageType;
  canonicalUrl: string;
  seoPageId: string;
}

export interface IFeedCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.feed;
  categoryId: string;
}

export interface IHashtagCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.hashtag;
  hashtagId: string;
}

export interface IArticleCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.article;
  groupId: string;
  mediaId: string;
  contentByTranslate: 0 | 1;
}

export interface IVideoCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.video;
  groupId: string;
  mediaId: string;
  contentByTranslate: 0 | 1;
}

export interface IPOICurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.poi;
  poiId: string;
}

export interface IDiscoverCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.discover;
  keyword: string;
  standardKeyword: string;
  hasBreadCrumb: boolean;
}

export interface IExperienceCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.experience | EPageType.experience_article | EPageType.experience_ugc;
  keyword: string;
  hasGPTAnswer: boolean;
  standardKeyword: string;
  unifiedKeyword: string;
  question: string;
  keywordSource: EKeywordSource;
}

export interface IUserCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.user;
  userLinkName: string;
  userId: string;
}

export interface IUserFollowCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.user_follow;
  userLinkName: string;
  userId: string;
}

export interface IUserTopicCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.user_topic;
  userLinkName: string;
  userId: string;
}

export interface ISearchSugCurrentTraffic extends ICurrentTraffic {
  pageType: EPageType.search_sug;
}

export type TCurrentTraffic =
  | IFeedCurrentTraffic
  | IHashtagCurrentTraffic
  | IPOICurrentTraffic
  | IArticleCurrentTraffic
  | IVideoCurrentTraffic
  | IDiscoverCurrentTraffic
  | IExperienceCurrentTraffic
  | IUserCurrentTraffic
  | IUserFollowCurrentTraffic
  | IUserTopicCurrentTraffic
  | ISearchSugCurrentTraffic;

export const CurrentTrafficUtil = {
  getPageIdFromTraffic: (traffic: TCurrentTraffic): string | null => {
    if (traffic.pageType === EPageType.feed) {
      return traffic.categoryId;
    }

    if (traffic.pageType === EPageType.hashtag) {
      return traffic.hashtagId;
    }

    if (traffic.pageType === EPageType.poi) {
      return traffic.poiId;
    }

    if (traffic.pageType === EPageType.article || traffic.pageType === EPageType.video) {
      return traffic.groupId;
    }

    if (traffic.pageType === EPageType.discover) {
      return traffic.keyword;
    }

    if (
      traffic.pageType === EPageType.experience ||
      traffic.pageType === EPageType.experience_article ||
      traffic.pageType === EPageType.experience_ugc
    ) {
      return traffic.keyword;
    }

    if (
      traffic.pageType === EPageType.user ||
      traffic.pageType === EPageType.user_follow ||
      traffic.pageType === EPageType.user_topic
    ) {
      return traffic.userId;
    }

    return null;
  },
};
